import React, {
    useContext
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { SgDateUtil, SgSessionStorageService, SgActiveTestsContext } from 'saga-modules';
import CommonConstants from 'sg-common-constants';
import { Link } from '@jutro/components';
import messages from './SgSPMRenewalSummaryInfo.messages';
import SgRenewalAddonSummary from '../sg-renewal-addon-summary';

function SgSPMRenewalSummaryInfo(props) {
    const {
        renewalDetails,
        updateDataAndJumpTo
    } = props;

    const translator = useContext(TranslatorContext);
    const { activeMvtTests } = useContext(SgActiveTestsContext);

    const makeChanges = (event) => {
        if (event) {
            event.preventDefault();
        }
        renewalDetails.isAmendingRenewal = true;
        SgSessionStorageService.removeItem(SgSessionStorageService.KEY.CEP_RENEWAL_ADDONS_PAGE_AVAILABLE);
        updateDataAndJumpTo('RenewalChanges', renewalDetails);
    };

    return (
        <>
            <div className="sgPolicyInfo">
                <div className="sgPolicyInfoName">{translator(messages.VehicleLabel)}</div>
                <div id="renewalDescription" className="sgPolicyInfoValue">{renewalDetails.description}</div>
            </div>
            {renewalDetails.drivers.map((driver, index) => {
                const driverContainerKey = `driver_${index}_container`;
                return (
                    <div key={driverContainerKey} className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.DriversLabel)}</div>
                        <div id={`driver_${index}`} className="sgPolicyInfoValue">{driver}</div>
                    </div>
                );
            })}
            {activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_3143)
            && (
                <div className="sgPolicyInfo">
                    <div className="sgPolicyInfoName">{translator(messages.CoverYearLabel)}</div>
                    <div id="coverStart" className="sgPolicyInfoValue">
                        {translator(messages.CoverYearInfo, {
                            startDate: SgDateUtil.getDateWithFullMonthName(renewalDetails.periodStart),
                            endDate: SgDateUtil.getDateWithFullMonthName(renewalDetails.periodEnd)
                        })}
                    </div>
                </div>
            )}
            {!activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_3143)
            && (
                <div className="sgPolicyInfo">
                    <div className="sgPolicyInfoName">{translator(messages.CSDLabel)}</div>
                    <div id="policyYear" className="sgPolicyInfoValue">{SgDateUtil.getDateWithFullMonthName(renewalDetails.periodStart)}</div>
                </div>
            )}
            <div className="sgPolicyInfo">
                <div className="sgPolicyInfoName">{translator(messages.CoverLabel)}</div>
                <div id="coverLevel" className="sgPolicyInfoValue">{renewalDetails.coverLevel}</div>
            </div>
            <SgRenewalAddonSummary renewalDetails={renewalDetails} />
            {!renewalDetails.isCashChequePayment
            && (
                <div className="sgRenewalMakeChangesLinkContainer">
                    <span>{translator(messages.MakeChangesLabel)}</span>
                    <Link
                        href="/"
                        onClick={makeChanges}
                        id="makeChangesAndRenew"
                    >
                        {translator(messages.MakeChangesLink)}
                    </Link>
                </div>
            )
            }
        </>
    );
}

export default SgSPMRenewalSummaryInfo;
